import { 
  implementRemap, 
  implementRemapVector2, 
  implementRemapVector3, 
  implementRemapVector4, 
  implementGetCornerFromIndex, 
  implementGetVertexFromIndex, 
  implementGetSpriteUV,
  implementRadialDist,
  implementCubicBezier
} from "../../common/webgl_common_funcs.js";

export const ShaderChunks: Record<string, string> = {
  remap: implementRemap(),
  remapVector2: implementRemapVector2(),
  remapVector3: implementRemapVector3(),
  remapVector4: implementRemapVector4(),
  getCornerFromIndex: implementGetCornerFromIndex(),
  getVertexFromIndex: implementGetVertexFromIndex(),
  getSpriteUV: implementGetSpriteUV(),
  radialDist: implementRadialDist(),
  cubicBezier: implementCubicBezier(),
};
